<ng-container>
  <a cf-link size="sm" (click)="back()">
    <svg cfIcon="chevron_down" class="tw:text-blue-50 tw:rotate-90"></svg>
    <span>{{ "back" | translate }}</span>
  </a>
</ng-container>
